import React from 'react';
import { Typography } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import './style.css';

const { Title } = Typography;

const PageHeader = ({ style, onBack, title, subTitle, extra, showIcon }) => {
    if (title) {
        style = {
            ...style,
            marginBottom: 16
        }
    }
    return (
        <div className="page-header" style={style}>
            <div className="page-header-inner">
                <div className="page-header-left">
                    {onBack && <ArrowLeftOutlined className="page-header-back" onClick={onBack} />}
                    {showIcon}
                    {title && <Title level={3} className="page-header-heading">{title}</Title>}
                    {subTitle && <Typography.Text className="page-header-subtitle">{subTitle}</Typography.Text>}
                </div>
                {extra && (
                    <div className="page-header-extra">
                        {React.Children.toArray(extra)}
                    </div>
                )}
            </div>
        </div>
    );
};

export default PageHeader;
